(function () {
    "use strict";

    angular
        .module("app")
        .directive("lastSearchHelp", ["SearchFactory", lastSearchHelp]);

    function lastSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.lastId = "";
                        scope.lastName = "";
                        scope.lastDesc = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.lastName === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.lastSearch(scope.brandId, function (last) {
                        scope.lastId = last ? last.LastId : "";
                        scope.lastName = last ? last.LastName : "";
                        scope.lastDesc = last ? last.LastDesc : "";
                        scope.displayValue = scope.lastName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            

                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.displayValue = scope.lastName;
                scope.prevDisplayValue = scope.displayValue;

                scope.$watch("lastName", function (newValue) {
                    scope.displayValue = newValue;
                });
            },
            scope: { lastId: "=", lastName: "=", lastDesc: "=", readOnly: "=", required: "=", controlName: "@", brandId: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

